import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/politica-privacidad',
    element: <PrivacyPage />
  },
  {
    path: '/aviso-legal',
    element: <LegalPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;